<app-navsec></app-navsec>
<div class="nosotros">
    <div class="col-12">
        <div class="card-group">
            <div class="card mt-3" style="border: none;">
                <div class="card-body text-center txto d-none d-lg-block d-xl-block">
                    <h2 class="card-title">¿QUIÉNES SOMOS?</h2>
                    <hr class="line">

                    <p class="card-text">
                        Para cuidarte a ti y a tu familia creamos a Torreón Market.
                    </p>
                    <p class="card-text">
                        Deseamos inspirarte, para que mejores tus hábitos y aumentes
                    </p>
                    <p class="card-text">
                      tu salud y belleza de forma natural.
                    </p>
                    <br>
                    <p class="card-text">
                     Ponemos a tu disposición desde la comodidad de tu hogar,
                  </p>
                  <p class="card-text">
                      productos naturales, fitoterapéuticos, cosméticos, suplementos y
                  </p>
                  <p class="card-text">
                    alimentos, de excelente calidad, y consejos útiles, para que
                  </p>
                  <p class="card-text">
                    puedas mejorar tu bienestar y calidad de vida.
                  </p>

                </div>
                <div class="card-body text-center txto d-xs-block d-sm-block d-md-block d-lg-none d-xl-none">
                  <h2 class="card-title">¿QUIÉNES SOMOS?</h2>
                  <hr class="line">
                  <p>
                    Para cuidarte a ti y a tu familia creamos a Torreón Market.
                    Deseamos inspirarte, para que mejores tus hábitos y aumentes
                    tu salud y belleza de forma natural. <br><br>
                    Ponemos a tu disposición desde la comodidad de tu hogar,
                    productos naturales, fitoterapéuticos, cosméticos, suplementos y
                    alimentos, de excelente calidad, y consejos útiles, para que
                    puedas mejorar tu bienestar y calidad de vida.
                  </p>
              </div>
            </div>
            <div class="card">
                <img src="../../../assets/img/nosotros.jpg" class="card-img-top" alt="...">
            </div>
        </div>
    </div>
</div>
<div class="contenido">
    <div class="title mt-5 d-none d-lg-block d-xl-block">
        <div class="col-md-12">
            <div class="card-group">
                <div class="card">
                    <div class="card-body">
                        <hr class="line2">
                    </div>
                </div>
                <div class="card">
                    <div class="card-body text-center">
                        <h2 class="ltTitle">NUESTROS VALORES</h2>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <hr class="line2">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="title mt-5 d-xs-block d-sm-block d-md-block d-lg-none d-xl-none">
      <div class="col-md-12">
          <div class="card-group">
              <div class="card">
                  <div class="card-body text-center">
                      <h2 class="ltTitle">NUESTROS VALORES</h2>
                      <hr class="line">
                  </div>
              </div>
          </div>
      </div>
  </div>

    <div class="cont">
        <ul>
            <li>
                <h5>AMOR: <small>Creemos que es muy importante que cuides con amor tu cuerpo y tu bienestar.</small></h5>
            </li>
            <br>
            <li>
              <h5>PASIÓN: <small>Deseamos que vivas cada día con pasión, apreciando todos los regalos que te da la vida.</small></h5>
            </li>
            <br>
            <li>
              <h5>FORTALEZA: <small>Que nuestra torre fuerte sea Dios, del cual proviene nuestra bendición (Prov. 18:10) y fortaleza.</small></h5>
            </li>
            <br>
            <li>
              <h5>RESPONSABILIDAD: <small>Ponemos a tu disposición productos naturales de excelente calidad y con todos sus registros  sanitarios. Cumplimos con toda la normativa vigente en el territorio colombiano.</small></h5>
            </li>
            <br>
            <li>
                <h5>ESPERANZA: <small>Deseamos ayudarte a afrontar la enfermedad con esperanza, brindándote soluciones cuando más lo necesites, aprovechando las bondades de la naturaleza.</small></h5>
            </li>
            <br>
            <li>
                <h5>ALEGRIA: <small>Queremos contagiarte alegría para que vivas cada día con la mejor actitud.</small></h5>
            </li>
        </ul>
    </div>
</div>
<div class="nosotros2">
    <div class="col-12">
        <div class="card-group">
            <div class="card">
                <img src="../../../assets/img/us.jpg" class="card-img-top" alt="...">
            </div>
            <div class="card mt-5" style="border: none;">
                <div class="card-body text-center txto">
                    <h2 class="card-title">¡QUEREMOS AYUDARTE!</h2>
                    <hr class="line">
                    <br>
                    <div class="text-left txto">
                        <ul style="list-style-image:url(../../../assets/img/check.png)">
                            <li style="color: #584604;">Si deseas sentirte cada vez mejor, tener calidad de vida y aumentar tu vitalidad. </li>
                            <br>
                            <li style="color: #584604;">Si estás atravesando algún problema de salud y estás buscando otras alternativas para sentirte mejor.</li>
                            <br>
                            <li style="color: #584604;">Si deseas resaltar tu belleza y cuidarte para verte excelente.</li>
                            <br>
                            <li style="color: #584604;">Si deseas aprovechar al máximo las bondades de la naturaleza, para cuidarte y cuidar a los que mas amas.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>
